import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import { useAuth } from "../contexts/AuthContext";
import { API_BASE_URL } from "../config";
import { generarMensajeWhatsApp } from "../utils/whatsapp";
import "../styles/Checkout.css";

const CheckoutForm = () => {
  const { cartItems, clearCart } = useCart();
  const { user } = useAuth();
  const navigate = useNavigate();

  const [nombre, setNombre] = useState("");
  const [direccion, setDireccion] = useState("");
  const [telefono, setTelefono] = useState("");
  const [metodoPago, setMetodoPago] = useState("efectivo");
  const [showConfirm, setShowConfirm] = useState(false);
  const [mensajeExito, setMensajeExito] = useState("");

  const total = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);

  // Prellenar con datos del usuario si están disponibles
  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/auth/profile`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        });

        if (res.ok) {
          const data = await res.json();
          setNombre(data.name || "");
          setDireccion(data.address || "");
          setTelefono(data.phone || "");
        }
      } catch (err) {
        console.error("❌ Error al obtener datos del perfil:", err);
      }
    };

    if (user?.token) {
      fetchProfileData();
    }
  }, [user]);


  const handleOpenConfirm = () => {
    if (!nombre || !direccion || !telefono) {
      alert("Por favor completa todos los campos.");
      return;
    }
    setShowConfirm(true);
  };

  const handleConfirm = async () => {
    const mensaje = generarMensajeWhatsApp({
      nombre,
      direccion,
      telefono,
      metodoPago,
      productos: cartItems,
    });

    const url = `https://wa.me/584146030657?text=${encodeURIComponent(mensaje)}`;

    const payload = {
      user_id: user?.id || null,
      customer_name: nombre,
      address: direccion,
      phone: telefono,
      payment_method: metodoPago,
      total: Number(total.toFixed(2)),
      items: cartItems.map(({ name, price, quantity }) => ({
        product_name: name,
        price,
        quantity,
      })),
    };

    try {
      const response = await fetch(`${API_BASE_URL}/orders/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setMensajeExito("✅ Orden creada con éxito. Redirigiendo...");
        window.location.href = url;
        clearCart();
        setTimeout(() => {
          navigate("/perfil");
        }, 2000);
      } else {
        console.error("Error al crear la orden.");
        alert("Error al registrar la orden. Intenta de nuevo.");
      }
    } catch (error) {
      console.error("Error al registrar orden:", error);
    }

    setShowConfirm(false);
  };

  return (
    <div className="checkout-container">
      <div className="category-header">
        <Link to="/" className="back-link">
          <i className="fas fa-arrow-left"></i>
        </Link>
        <h2 className="checkout-title">Finalizar pedido</h2>
      </div>

      {mensajeExito && <div className="success-message">{mensajeExito}</div>}

      <input
        type="text"
        placeholder="Nombre"
        value={nombre}
        onChange={(e) => setNombre(e.target.value)}
        className="checkout-input"
      />
      <input
        type="text"
        placeholder="Dirección"
        value={direccion}
        onChange={(e) => setDireccion(e.target.value)}
        className="checkout-input"
      />
      <input
        type="tel"
        placeholder="Teléfono"
        value={telefono}
        onChange={(e) => setTelefono(e.target.value)}
        className="checkout-input"
      />
      <select
        value={metodoPago}
        onChange={(e) => setMetodoPago(e.target.value)}
        className="checkout-select"
      >
        <option value="Efectivo">Efectivo</option>
        <option value="Transferencia">Transferencia</option>
        <option value="Pago Móvil">Pago Móvil</option>
        <option value="Binance">Binance</option>
      </select>

      <button className="checkout-button" onClick={handleOpenConfirm}>
        Enviar pedido
      </button>

      {showConfirm && (
        <div className="confirm-overlay">
          <div className="confirm-modal">
            <h3>Confirmar Pedido</h3>
            <p><strong>Cliente:</strong> {nombre}</p>
            <p><strong>Dirección:</strong> {direccion}</p>
            <p><strong>Teléfono:</strong> {telefono}</p>
            <p><strong>Método de pago:</strong> {metodoPago}</p>
            <ul>
              {cartItems.map((item) => (
                <li key={item.id}>
                  {item.name} x{item.quantity} - ${item.price * item.quantity}
                </li>
              ))}
            </ul>
            <p><strong>Total:</strong> ${total.toFixed(2)}</p>
            <div className="confirm-buttons">
              <button onClick={handleConfirm} className="confirm-yes">Confirmar y enviar</button>
              <button onClick={() => setShowConfirm(false)} className="confirm-no">Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckoutForm;
